import { render, staticRenderFns } from "./Kit.vue?vue&type=template&id=15300c85"
import script from "./Kit.vue?vue&type=script&lang=js"
export * from "./Kit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports